import React from "react";
import { ScreenGtLg, ScreenLtLg } from "app/components/MediaQueries";
import env from "helpers/env";
import { Class, StudioClass, SubscriptionProvider } from "services/graphql";
import { usePrimarySubscription } from "hooks/Subscriptions/usePrimarySubscription";
import { DesktopSubscribeModalWrapper } from "../DesktopSubscribeModalWrapper";
import { MobileSubscribeModalWrapper } from "../MobileSubscribeModalWrapper";
import { UpgradePlanFLow } from "../UpgradePlanFlow";
import { StartSubscriptionFlow } from "../StartSubscriptionFlow";
import { SubscribeModalContext } from "../context";
import { ReactivateSubscriptionFlow } from "../ReactivateSubscriptionFlow";
import { MobileSubscriberModal } from "../MobileSubscriberModal";

interface Props {
  classData: Class | StudioClass;
  closeModal(): void;
  isOpen: boolean;
}

export const ClassSubscribeModal = ({
  classData,
  isOpen,
  closeModal,
}: Props) => {
  const { primarySubscription } = usePrimarySubscription();
  const { isActive: isSubscriptionActive } = primarySubscription || {};

  if (!isOpen || !classData) {
    return null;
  }

  const previewSrc = `${env("PUBLIC_ASSET_PATH")}/class-thumbnails/${
    classData.slug
  }-basic.jpg`;
  const capitalizedAccessType =
    classData?.accessType.charAt(0).toUpperCase() +
    classData?.accessType.slice(1);
  const classAccessHeader = `This class is available on the ${capitalizedAccessType} subscription plan.`;

  const canReactivate = primarySubscription?.isReactivatableV2;
  const checkoutHeader =
    !isSubscriptionActive && canReactivate
      ? "Reactivate your subscription"
      : "Start your subscription";
  const canUpgrade = isSubscriptionActive && !canReactivate;
  const previewHeader = canUpgrade
    ? "Upgrade your subscription"
    : checkoutHeader;
  const CheckoutFlow = canReactivate
    ? ReactivateSubscriptionFlow
    : StartSubscriptionFlow;
  const SubscribeFlow = canUpgrade ? UpgradePlanFLow : CheckoutFlow;

  if (
    !isSubscriptionActive &&
    primarySubscription?.provider?.name === SubscriptionProvider.Revenuecat
  ) {
    return <MobileSubscriberModal closeModal={closeModal} />;
  }

  return (
    <SubscribeModalContext.Provider value={{ closeModal }}>
      <ScreenGtLg>
        <DesktopSubscribeModalWrapper
          closeModal={closeModal}
          previewSrc={previewSrc}
          previewHeader={previewHeader}
          accessHeader={classAccessHeader}
        >
          <SubscribeFlow accessTypeRequired={classData.accessType} />
        </DesktopSubscribeModalWrapper>
      </ScreenGtLg>
      <ScreenLtLg>
        <MobileSubscribeModalWrapper
          closeModal={closeModal}
          accessHeader={classAccessHeader}
        >
          <SubscribeFlow accessTypeRequired={classData.accessType} />
        </MobileSubscribeModalWrapper>
      </ScreenLtLg>
    </SubscribeModalContext.Provider>
  );
};
